export enum JobSource {
    Active = 'jobs',
    Closed = 'closed',
    Export = 'export',
    Manually = 'manually',
    Imported = 'imported',
    Recurring = 'recurring',
    BulkImport = 'bulkImport',
}
